{
  "fr": {
    "wordClouds": {
      "buttons": {
        "addWord": "Ajouter un mot"
      },
      "headers": {
        "options": "Options",
        "wordCloud": "Nuage de mots"
      },
      "labels": {
        "show": "Afficher le nuage de mots",
        "showBeforeSubmit": "Nuage de mots visible avant l'entrée des mots",
        "visitorCanWrite": "Le visiteur peut ajouter des mots",
        "wordOccurences": "Mots avec fréquence",
        "words": "Mots (un mot par ligne)"
      },
      "links": {
        "save": "Enregistrer le nuage de mots en tant qu'image"
      },
      "placeholders": {
        "addWord": "Ajouter un mot..."
      }
    }
  }
}
